import _get from "lodash/get";
/**
 * @module
 *
 * @description Article selectors.
 */
/**
 * Note: this file is reasonably alphabetized.
 */
import { DISPLAY_FLAGS } from '../constants';
import { getNwData } from '../utils';

/**
 * Get Article type.
 *
 * @param   {Object} article    WordPress Article.
 *
 * @return  {string}            Article type.
 */
export var getArticleType = function getArticleType(article) {
  return _get(getNwData(article), 'article_type');
};

/**
 * Get Article synopsis.
 *
 * @param   {Object} article    WordPress Article.
 *
 * @return  {string}            Article synopsis.
 */
export var getSynopsis = function getSynopsis(article) {
  return _get(article, 'nw_synopsis');
};

/**
 * Get flag for showing editorial standards
 *
 * @param {Object} article      WP article.
 *
 * @return {boolean} editorial   standards flag
 */
export var getEditorialStandardsFlag = function getEditorialStandardsFlag(article) {
  return _get(getNwData(article), 'editorial_disclaimer') !== DISPLAY_FLAGS.NONE;
};